import refreshCart, { sectionsRendering } from './refreshCart';
import handleError from './handleError';
import interactionBlocker from './interactionBlocker';
import { getSectionsToRenderByUpdate } from './cartSections';
import { changeQuantityOnNewItem } from './cartEditItem';

/**
 * Update the quantity of an item in the cart by its ID.
 * Additionally, it will evaluate if the availability over target product is enough and allowed.
 * @param {Number} quantity
 * @param {String} itemId
 */
export default async function (quantity, itemId) {
  // Cart Data object
  let cartData;
  // Body request for /change.js fetch
  const changeItemFormData = {
    id: itemId,
    quantity,
    sections: getSectionsToRenderByUpdate()
      .map((section) => section.section)
      .join(','),
  };

  try {
    cartData = await changeQuantityOnNewItem(cartData, changeItemFormData, getSectionsToRenderByUpdate());
    sectionsRendering(cartData.sections, { cartData });
    // Interaction blocker: unblock cart
    interactionBlocker();
    // Defer this block of code because they are no user-visible tasks
    setTimeout(() => {
      refreshCart(cartData);
    }, 0);
  } catch (error) {
    // Interaction blocker: unblock cart
    console.error(error);
    interactionBlocker();
    handleError(error);
  }
}
